import React, { Component } from 'react';
import { Link } from 'react-router-dom';
class Simulacro2025 extends Component {
  componentDidMount() {
    window.startx();
  }
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Simulacro Nacional 2025</h2>
          </header>
          <div className="containerimagenblog">
          <img className="imagenBlog" src="images/Blog/portada1.jpg" alt="Simulacro 2025" />
          </div>
          <span className="containerblog">
              <div className="align justify">
                <p>
                  El Rehilete reafirma su compromiso con la seguridad y la prevención
                  El 19 de septiembre de 2025, el Museo Interactivo El Rehilete se sumó activamente al Simulacro Nacional, participando 
                  junto con instituciones, empresas y ciudadanos de todo el país en una jornada dedicada a fortalecer la cultura de la prevención 
                  y la preparación ante emergencias.
                </p>
                <p>
                Durante el ejercicio, visitantes, niñas, niños y el personal del museo colaboraron con entusiasmo y responsabilidad 
                para llevar a cabo una evacuación ordenada y exitosa, demostrando la importancia del trabajo en equipo y la atención
                 a los protocolos de seguridad.
                </p>
                <p>
                  En El Rehilete sabemos que la cultura de la prevención salva vidas. Por ello, participar en este tipo de acciones 
                  nos permite no solo mejorar nuestros tiempos de respuesta, sino también fomentar la conciencia colectiva sobre la 
                  importancia de estar preparados ante cualquier eventualidad.
                  Agradecemos profundamente la participación de todas y todos los que formaron parte de este ejercicio, reafirmando 
                  nuestro compromiso de mantener un espacio seguro, educativo y confiable para quienes nos visitan.
                </p>
                <h3>
                  Prevenir es cuidar, y cuidar es aprender.
                </h3>
                <img className="imagenBlogmini" src="images/Blog/sismo25-1.jpg" alt="Sismo1"/>
                <img className="imagenBlogmini" src="images/Blog/sismo25-2.jpg" alt="Sismo2"/>
                <img className="imagenBlogmini" src="images/Blog/sismo25-3.jpg" alt="Sismo3"/>
                <img className="imagenBlogmini" src="images/Blog/sismo25-4.jpg" alt="Sismo4"/>
                <img className="imagenBlogmini" src="images/Blog/sismo25-5.jpg" alt="Sismo5"/>
                <img className="imagenBlogmini" src="images/Blog/sismo25-6.jpg" alt="Sismo6"/>
                <img className="imagenBlogmini" src="images/Blog/sismo25-7.jpg" alt="Sismo7"/>
                <img className="imagenBlogmini" src="images/Blog/sismo25-8.jpg" alt="Sismo8"/>
            </div>
            <div>
              <div className="containerjuego">
                <Link className="button" to="/blog">
                Regresar
              </Link>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default Simulacro2025;